export default __webpack_public_path__ + "static/cbb-ab7005768897c896893d330e2b08d912.png";